<template>
  <div class="lg:block hidden bg-primary pt-20 px-8 pb-12">
    <ul class="gap-y-4 flex flex-col min-h-full">
      <li
        v-if="fullName"
        class="ui-text-sm text-white font-medium uppercase mb-4"
      >
        {{ fullName }}
      </li>
      <li v-if="generalStore.isAuthenticated">
        <nuxt-link
          class="ui-text-m text-white hover:underline underline-offset-2"
          :to="localePath('/profile')"
          active-class="underline"
        >
          {{ $t("myProfile") }}
        </nuxt-link>
      </li>
      <li>
        <nuxt-link
          class="ui-text-m text-white hover:underline underline-offset-2"
          :to="localePath('/orders')"
          active-class="underline"
        >
          {{ $t("ordersHistory") }}
        </nuxt-link>
      </li>
      <li v-if="generalStore.isAuthenticated">
        <nuxt-link
          class="ui-text-m text-white hover:underline underline-offset-2"
          :to="localePath('/favorites')"
          active-class="underline"
        >
          {{ $t("wishlist") }}
        </nuxt-link>
      </li>
      <li v-if="generalStore.isAuthenticated" class="mt-auto">
        <div
          class="ui-text-m text-white cursor-pointer inline-block capitalize hover:underline"
          @click="onLogout"
        >
          {{ $t("logout") }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

const localePath = useLocalePathPolyfill();
const router = useRouter();

const { logout } = useAuth();
const generalStore = useGeneralStore();
const { userInfo } = storeToRefs(generalStore);

const fullName = computed(() => {
  const firstName = userInfo.value?.first_name || "";
  const lastName = userInfo.value?.last_name || "";
  return `${firstName} ${lastName}`.trim();
});

async function onLogout() {
  try {
    await logout();
  } catch (error) {
    console.log(error);
  } finally {
    await Promise.all([generalStore.getCart(), generalStore.getWishList()]);
    await router.replace(localePath("/"));
  }
}
</script>
